import { connect } from 'react-redux';
import { Checkbox } from '@optimus-web/core';
import { isResourceSelected } from '../../../selectors/resources';
import { deselectResource, selectResource } from '../../../actions/resources';

const ResourceCheckbox = ({ isSelected, handleClick }: $TSFixMe) => (
    <Checkbox checked={isSelected} onChange={handleClick} />
);

export default connect(
    // @ts-expect-error $TSFixMeError: Property 'id' does not exist on type '{}'.
    (state, { id }) => ({
        isSelected: isResourceSelected(state, { resourceId: id }),
    }),
    // @ts-expect-error $TSFixMeError: Property 'id' does not exist on type '{}'.
    (dispatch, { id }) => ({
        handleClick: (_event: $TSFixMe, checked: $TSFixMe) => {
            if (checked) {
                dispatch(selectResource(id));
            } else {
                dispatch(deselectResource(id));
            }
        },
    })
)(ResourceCheckbox);
